import React, { useState, useEffect, useRef, useCallback } from 'react';
import { Button, Form, Col, Modal, Row, OverlayTrigger, Tooltip, Image, Table } from 'react-bootstrap';
import moment from 'moment/moment';
import Loader from '../Loader/Loader';
import Toaster from '../Toaster/Toaster';
import { CSVLink } from "react-csv";
import callAPI from '../../../commonservices/APIRequests';
import { convertToBaseFormatDate, currencifyInDollars, MaskAccountNumber } from '../../../commonservices/CommonMethods';
import ReactTable, { DateRangeFilter, filterDateRange } from '../../Shared/ReactTable/ReactTable';
import { useReactToPrint } from 'react-to-print';
import logo from '../../../assets/images/logo.png';
import filterlogo from '../../../assets/images/TableFilters/TableFilterIcon.svg';
import printlogo from '../../../assets/images/TableFilters/TableFilterPrintIcon.svg';
import exportlogo from '../../../assets/images/TableFilters/TableFilterDownloadIcon.svg';
import { AlertOctagon, X } from 'lucide-react';
import PopupIcons_ViewTransaction from '../../../assets/images/Popup-Icons/PopupIcons_View_Transaction_White.svg'
import SelectBox from '../../Shared/common/components/Shared_FormControls/SelectBox/SelectBox';
import CustomisedReactDatePicker from '../common/components/Shared_FormControls/CustomisedReactDatePicker/CustomisedReactDatePicker';
import TableFiltersWrapper from '../common/components/TableComponents/TableFiltersWrapper/TableFiltersWrapper';
import RefreshIcon from '../../../assets/images/TableFilters/TableFilterRefreshIcon.svg';

let csvData = [];
let printData = [];
const SharedBankTransaction = (props) => {
    const dt = new Date();

    const printRef = useRef();

    const [bankOptions, setBankOptions] = useState([]);
    const [bankDetails, setBankDetails] = useState({})
    const [selectedBankID, setSelectedBankID] = useState(props.bankId);
    const [transactionsList, setTransactionsList] = useState([]);
    const [accountBalance, setAccountBalance] = useState();
    const [to, setTo] = useState(moment(dt).format('yyyy-MM-DD'));
    dt.setDate(dt.getDate() - 60);
    const [from, setFrom] = useState(moment(dt).format('yyyy-MM-DD'));
    const [startDate, setStartDate] = useState();
    const [endDate, setEndDate] = useState()
    const [isLoaded, setLoaded] = useState(true);
    const [refreshCw, setRefreshCw] = useState(false)
    const [showFilters, setShowFilters] = useState(false);
    const [series, setChartDetails] = useState([]);
    const [plaidConnectionFailedDate, setPlaidConnectionFailedDate] = useState()
    const [transactionsUpdatedDate, setTransactionsUpdatedDate] = useState("")
    const [rerenderPrintData, setRerenderPrintData] = useState();
    const [columnsTL, setColumnsTL] = useState([]);
    const [rerenderCSVData, setRerenderCSVData] = useState();

    const [toasterInfo, setToaster] = useState({
        showToaster: false,
        content: '',
        header: '',
        class: ''
    });

    const toasterClose = () => {

        setToaster({
            showToaster: false,
            content: '',
            header: '',
            class: ''
        })

    }
    useEffect(() => {
        getBankOptions(props.dealerId)
        viewTransactions();
    }, [])
    const handlePrint = useReactToPrint({
        content: () => printRef.current,
    });
    useEffect(() => {
        if (rerenderPrintData !== undefined)
            handlePrint();


    }, [rerenderPrintData]);

    //getBank list
    const getBankOptions = (dealer_id) => {
        setLoaded(false)
        return callAPI.get('/payment/api/v1/plaid/getDealerBanks', { dealerId: dealer_id })
            .then((response) => {
                if (response.status === 200) {
                    setBankOptions(response.data.accounts ? response.data.accounts.map((el) => ({
                        value: el._id,
                        label: `${el.account?.bankName} (${el.account?.accountNumber.substr(-4)})`
                    })) : [])
                    setLoaded(true)
                } else {
                    setBankOptions([])
                    console.error(response.message)
                    setLoaded(true)
                }
            })
    }

    const setCSVData = useCallback((filteredData) => {
        csvData = filteredData.map(item => {

            return {
                Name: item.Name,
                Category: item.Category,
                Channel: item.Channel,
                PaymentDate: item.PaymentDate ? convertToBaseFormatDate(item.PaymentDate, true, false) : '',
                Amount: item.Amount ? currencifyInDollars(item.Amount) : ''
            }

        });

        printData = filteredData.map((item, index) => {
            return (<tr key={"dealerTransaction-" + index}>

                <td>{item.Name}</td>
                <td>{item.Category}</td>
                <td>{item.Channel}</td>
                <td>{item.PaymentDate ? convertToBaseFormatDate(item.PaymentDate, true, false) : ''}</td>
                <td>{item.Amount ? currencifyInDollars(item.Amount) : ''}</td>
            </tr>)

        });
    }, []);

    //set columns for table
    useEffect(() => {

        setColumnsTL([
            {
                Header: 'Name',
                accessor: 'Name',
                filter: 'contains',
                Cell: props => <p style={{ maxWidth: '400px' }} className="mb-0">{props.value ? props.value : null}</p>
            },
            {
                Header: 'Category',
                accessor: 'Category',
                filter: 'contains'
            },
            {
                Header: 'Channel',
                accessor: 'Channel',
                filter: 'contains'
            },
            {
                Header: 'Payment Date',
                accessor: 'PaymentDate',
                filter: filterDateRange,
                Filter: DateRangeFilter,
                Cell: props => <span>{props.value ? convertToBaseFormatDate(props.value, true, false) : ''}</span>
            },
            {
                Header: 'Amount',
                accessor: 'Amount',
                filter: 'contains',
                Cell: props => <span>{props.value ? currencifyInDollars(props.value) : ''}</span>
            }

        ])

    }, [transactionsList]);

    //get Transaction
    const viewTransactions = (event, plaidSyncFlag) => {
        const req = {
            dealer_id: props.dealerId,
            bankId: selectedBankID ? selectedBankID : props.bankId,
            startDate: from ? moment(from).format('YYYY-MM-DD') : '',
            endDate: to ? moment(to).format('YYYY-MM-DD') : '',
            isPlaidSync: plaidSyncFlag
        }
        setLoaded(false);
        return callAPI.get('/payment/api/v1/plaid/getTransactions', req)
            .then((response) => {
                if (response.status === 200) {
                    const transactions = response.data.transactions && response.data.transactions.length > 0 ?
                        response.data.transactions.map(item => {
                            return {
                                Name: item.name,
                                Channel: item.payment_channel,
                                PaymentDate: item.date,
                                Amount: item.amount,
                                Category: item.category.join(', '),
                                markAsRed: item.markAsRed
                            }
                        }) : [];

                    setTransactionsList(transactions);
                    setAccountBalance(response.data.accountBalance);
                    // // setSelectedBankDetails(response.data ? response.data : {})
                    setPlaidConnectionFailedDate(response.data.plaidConnectionFailedDate)
                    setTo(response.data.endDate ? response.data.endDate : to)
                    setFrom(response.data.startDate ? response.data.startDate : from)
                    setEndDate(response.data && response.data.plaidError && response.data.plaidError.includes("Login Required") ? (moment(response.data.transactionsEndDate).format('yyyy-MM-DD')) : endDate)
                    // setLoaded(true);
                    setBankDetails({
                        bankName: response?.data?.bankName,
                        accountNumber: response?.data?.accountNumber,
                        mask: response?.data?.mask,
                        bankBalance: response?.data?.accountBalance,
                        plaidConnectionFailedDate: response?.data?.bankDetails?.plaidConnectionFailedDate,
                    });
                    if (response?.data?.transactionsUpdatedDate) {
                        setTransactionsUpdatedDate(response.data.transactionsUpdatedDate)
                    }
                    setLoaded(true);
                    setRefreshCw(false)
                }
                else {

                    setLoaded(true);
                    setRefreshCw(false)
                    let errMessage = '';

                    if (response && response.message) {
                        errMessage = response.message
                    }
                    else {
                        errMessage = 'Something went wrong.'
                    }
                    setToaster({
                        header: 'Error',
                        class: 'error-toaster',
                        content: errMessage,
                        showToaster: true
                    });
                    setTransactionsList([]);
                    setAccountBalance('');
                    setPlaidConnectionFailedDate('')
                }

            })
    }

    return (
        <Modal className={`bank-transactions-popup default-medium-popup default-popup modal-backdrop-bg-color`} show={props.showModalBT}
            onHide={props.cancelBT} backdrop={props.isStatic ? "static" : null} centered={props.centered}>
            <Modal.Header className='darkblue-bg-color' closeButton={props.isStatic ? false : true}>
                <Modal.Title>
                    {/* {props.icon ? props.icon : <span className='popup-title-icon'><MapPin /></span>} */}
                    <span className='popup-title-icon'><img src={PopupIcons_ViewTransaction} alt="logo" /></span>
                    <span className='flex-grow-1'>{props.modalTitle ? props.modalTitle : 'Transactions'}</span>
                    <span className='popup-close-icon'><X size={20} /></span>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {toasterInfo.showToaster ?
                    <Toaster myClassName={toasterInfo.class} onClose={toasterClose}
                        header={toasterInfo.header} content={toasterInfo.content}></Toaster>
                    : null}
                <div>
                    <Loader show={!isLoaded} styleType='absolute' />
                    <p className='dealer-name-popup mb-2'>{props.dealerName ? props.dealerName : (props.dealerDetails && props.dealerDetails.dealerName) ? props.dealerDetails.dealerName : ''} ({props.dealerReference ? props.dealerReference : (props.dealerDetails && props.dealerDetails.dealerReference) ? props.dealerDetails.dealerReference : ''})</p>
                    <Row className="pl-0 pr-3 pb-0 mb-3">
                        <Col>
                            <Form.Row className="datePickerStyles mb-3">
                                {
                                    props?.showBankSelection ?
                                        <Form.Group as={Col} md={3} controlId="formACHFrom" >
                                            <SelectBox
                                                zeroMargin
                                                label='Select Bank'
                                                name="Daily Balance"
                                                objectKey='dailyBalance'
                                                value={selectedBankID}
                                                onChange={(key, value) => setSelectedBankID(value)}
                                                options={bankOptions}
                                            />
                                        </Form.Group> : null
                                }
                                <Form.Group as={Col} md={3} className="datePickerIconStyles clear-Date-For-Datepicker">
                                    {/* <Form.Label className="label-color single-line-label mb-0">From</Form.Label> */}
                                    <CustomisedReactDatePicker
                                        zeroMargin
                                        label='From'
                                        dateFormat="MM-dd-y"
                                        autoPlacement="bottom"
                                        value={from ? new Date(moment(from).format('MM-DD-YYYY')) : null}
                                        onChange={(type, date) => setFrom(date)}
                                        objectKey='from'
                                    />
                                </Form.Group>

                                <Form.Group as={Col} md={3} className="datePickerIconStyles clear-Date-For-Datepicker">
                                    {/* <Form.Label className="label-color single-line-label mb-0">To</Form.Label> */}
                                    <CustomisedReactDatePicker
                                        zeroMargin
                                        label='To'
                                        dateFormat="MM-dd-y"
                                        autoPlacement="bottom"
                                        value={to ? new Date(moment(to).format('MM-DD-YYYY')) : null}
                                        onChange={(type, date) => setTo(date)}
                                        objectKey='to'
                                    />
                                </Form.Group>
                                <div className='col-'>
                                    <Button type="button" variant="primary" md={3}
                                        className="default-btn mt-2"
                                        onClick={(event) => viewTransactions(event, null)}>
                                        Get
                                    </Button>
                                </div>
                            </Form.Row>
                            <Row>
                                <Col md={12}>
                                    <div className='d-flex'>
                                        {
                                            bankDetails ?
                                                <>
                                                    <div className="mr-4 mb-1">
                                                        <p className="content-text-14px">
                                                            {bankDetails.bankName ? <>
                                                                <span className="bold-700">Bank Name: </span>
                                                                {bankDetails.bankName ? bankDetails.bankName : ''}
                                                                <span className='ml-1'>({bankDetails.accountNumber ? MaskAccountNumber(true, bankDetails.accountNumber) : ''})</span>
                                                            </> : null}
                                                        </p>
                                                    </div>
                                                    <div className="mr-4 mb-1">
                                                        {bankDetails.mask ?
                                                            <p className="content-text-14px">
                                                                <span className="bold-700">Mask: </span>
                                                                {bankDetails.mask}
                                                            </p>
                                                            : ''}
                                                    </div>
                                                    <div className="mr-4 mb-1">
                                                        {bankDetails.bankBalance ?
                                                            <p className="content-text-14px mb-1">
                                                                <span className="bold-700">Account Balance: </span>
                                                                {currencifyInDollars(bankDetails.bankBalance)}
                                                            </p> : null
                                                        }
                                                    </div>
                                                </>
                                                : null}

                                        {
                                            plaidConnectionFailedDate ?
                                                <div>
                                                    <p className="content-text-14px mb-1">
                                                        <span className="bold-700">Plaid Connection Failed on:  </span>
                                                        {convertToBaseFormatDate(plaidConnectionFailedDate)}
                                                    </p>
                                                </div> : null
                                        }
                                    </div>

                                    
                                    {!refreshCw ? <p className='d-flex align-items-center mt-1'>
                                        <AlertOctagon size={18} className="mr-1 content-text-color" />
                                        {bankDetails?.plaidConnectionFailedDate ?
                                            <span>Please <span className="text-decoration-underline bold-500">click here</span> to get real-time balance.</span>
                                            :
                                            <span>Please <span className="cursor-pointer text-decoration-underline bold-700"
                                                onClick={(event) => {viewTransactions(event, true); setRefreshCw(true);}}
                                            >
                                                click here</span> to get real-time transactions.</span>}
                                    </p> :
                                        <p>We are fetching real time transactions from plaid - In Progress
                                            {/* <RefreshCw style={{ marginLeft: '15px' }} size={18} width={30} height={30} */}
                                            <span className='ml-2'>
                                                <Image src={RefreshIcon} width={12}
                                                    className="rotate-refresh align-self-center" />
                                            </span>
                                        </p>
                                    }
                                    <div>
                                        {transactionsUpdatedDate ? <p className='mt-1'>Updated on: {convertToBaseFormatDate(transactionsUpdatedDate, true, true)} </p> : null}
                                    </div>
                                </Col>
                                    <TableFiltersWrapper>
                                        {!showFilters ?
                                            <OverlayTrigger placement="bottom"
                                                overlay={
                                                    <Tooltip>Filter</Tooltip>}>
                                                <Button className="action-item" onClick={() => setShowFilters(!showFilters)}>
                                                    <img src={filterlogo} alt="printlogo" />
                                                </Button>
                                            </OverlayTrigger> :
                                            <OverlayTrigger placement="bottom"
                                                overlay={
                                                    <Tooltip>Filter</Tooltip>}>
                                                <Button className="action-item active-icon" onClick={() => setShowFilters(!showFilters)}>
                                                    <img src={filterlogo} alt="printlogo" />
                                                </Button>
                                            </OverlayTrigger>
                                        }
                                        <OverlayTrigger placement="bottom"
                                            overlay={
                                                <Tooltip>Print</Tooltip>}>
                                            <Button onClick={() => setRerenderPrintData(!rerenderPrintData)} className="action-item anchor-btn">
                                                <img src={printlogo} alt="printlogo" />
                                            </Button>
                                        </OverlayTrigger>
                                        <OverlayTrigger placement="bottom"
                                            overlay={
                                                <Tooltip>Download</Tooltip>}>
                                            <CSVLink asyncOnClick={true} onClick={() => setRerenderCSVData(!rerenderCSVData)} data={csvData} filename={"DealerTransactions.csv"} className="action-item" target="_blank">
                                                <img src={exportlogo} alt="printlogo" />
                                            </CSVLink>
                                        </OverlayTrigger>
                                    </TableFiltersWrapper>
                            </Row>

                        </Col>

                    </Row>

                    <Row className="m-0">
                        <Col className="p-0">
                            <ReactTable
                                columns={columnsTL}
                                data={transactionsList}
                                showFilters={showFilters}
                                autoResetFilters={!showFilters}
                                filteredDataSync={(items) => setCSVData(items)}
                                rowProps={
                                    row => ({
                                        className: row.original.markAsRed ? 'normal common-warning-color' : 'normal'
                                    })}
                            />
                        </Col>
                        <div className="myinventory-table d-none">
                            <Row ref={printRef}>
                                <Col xs={12}>
                                    <Row className="mb-3 align-items-center">
                                        <Col xs={4}>
                                            <Image width={80} src={logo} fluid />
                                        </Col>
                                        <Col xs={4} className='text-center'>
                                            <h3>Dealer Transactions</h3>
                                            <p class="mb-0">
                                                <span className="bold-500 mr-1">Dealer:</span>
                                                <span>{props.dealerName ? props.dealerName : (props.dealerDetails && props.dealerDetails.dealerName) ? props.dealerDetails.dealerName : ''} ({props.dealerReference ? props.dealerReference : (props.dealerDetails && props.dealerDetails.dealerReference) ? props.dealerDetails.dealerReference : ''})</span>
                                            </p>
                                            <p class="mb-0">
                                                {accountBalance ?
                                                    <p className="content-text-14px mb-0">
                                                        <span className="bold-500">Account Balance:</span>
                                                        {currencifyInDollars(accountBalance)}
                                                    </p> : null
                                                    // <p className="content-text-14px mb-0">
                                                    //     <span className="bold-500 ">Plaid Connection Failed on:  </span>
                                                    //     {convertToBaseFormatDate(plaidConnectionFailedDate)}
                                                    // </p>
                                                }
                                            </p>
                                            <p class="mb-0">
                                                <span className="bold-500 mr-1">Bank Name:</span>
                                                <span>{bankDetails?.bankName}</span>
                                            </p>
                                            <p class="mb-0">
                                                <span className="bold-500 mr-1">Mask:</span>
                                                <span>{bankDetails.mask}</span>
                                            </p>
                                        </Col>
                                    </Row>
                                </Col>
                                <Col xs={12}>
                                    <Table hover responsive>
                                        <thead className="table-header-bg-color pt-2 pb-2">
                                            <tr>
                                                <th>Name</th>
                                                <th>Category</th>
                                                <th>Channel</th>
                                                <th>Payment Date</th>
                                                <th>Amount</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {printData}
                                        </tbody>
                                    </Table>
                                </Col>
                            </Row>
                        </div>
                    </Row>
                </div>
            </Modal.Body>
            {/* <Modal.Footer>
                <Button variant="primary" className="default-btn" onClick={(event) => props.primaryAction(event)}>{props.primaryActionLabel ? props.primaryActionLabel : "Yes"}</Button>
                <Button variant="outline-secondary" className="default-btn" onClick={(event) => props.secondaryAction(event)}>{props.secondaryActionLabel ? props.secondaryActionLabel : "No"}</Button>
            </Modal.Footer> */}
        </Modal>
    )
}

export default SharedBankTransaction
